import React from 'react';
import styled from 'styled-components';

const RightSection = styled.div`
  width: 50%;
  padding: 8px 0 8px 40px;
`;

export default RightSection;
